import React, { useEffect } from "react";

import { ReasonKinds } from "@featbit/js-client-sdk";

import { Navigate, checkMeasurementCookieConsent, isFeatureFlagsEnabled, useCookieConsent, useFeatureFlag, useLocation, useUserContext } from "utils";

import { FEATURE_FLAGS, SOILSIGHT_LANDING_STEP, SOILSIGHT_ROUTE } from "consts";

import { SoilSightFlowOverlay } from "pages/app/soilsight-pre-login/SoilSightFlowOverlay";
import { PreLoginLandingBody } from "pages/app/soilsight-pre-login/components/PreLoginLandingBody";
import { PreLoginLayout } from "pages/app/soilsight-pre-login/components/PreLoginLayout";
import { flushPendingSoilSightEvents, trackSoilSightFlowStart, trackSoilSightVirtualPageView } from "pages/app/soilsight-pre-login/utils/acquisitionTracking";

const SoilSightPreLoginFlow = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    function trackFlowEntry() {
      trackSoilSightFlowStart();
      if (pathname === SOILSIGHT_ROUTE) trackSoilSightVirtualPageView(SOILSIGHT_LANDING_STEP);
    }

    trackFlowEntry();
  }, [pathname]);

  return (
    <>
      <PreLoginLayout>
        <PreLoginLandingBody />
      </PreLoginLayout>
      <SoilSightFlowOverlay />
    </>
  );
};

export const SoilSightPreLoginGate = () => {
  const { isEnabled, kind } = useFeatureFlag(FEATURE_FLAGS.SOIL_SIGHT_INTEGRATION);
  const { user } = useUserContext();
  const hasMeasurementConsent = useCookieConsent(checkMeasurementCookieConsent);

  // Consent usually lands after the visitor leaves the flow, and GTM starts only then.
  // We replay above the redirect, because no other page flushes this queue.
  useEffect(() => {
    if (hasMeasurementConsent) flushPendingSoilSightEvents();
  }, [hasMeasurementConsent]);

  if (!user) return <SoilSightPreLoginFlow />;

  // An env-disabled SDK stays ClientNotReady forever, so we wait on the flag only when the SDK can answer.
  if (kind === ReasonKinds.ClientNotReady && isFeatureFlagsEnabled()) return null;

  // /scenarios-landing-page is mounted only while the flag is on, so without it we would land on ErrorPage.
  return <Navigate to={isEnabled ? "/scenarios-landing-page" : "/home"} replace />;
};
